export const environment = {
  production: true,
  showDeepSeekFunction:false,
  showDataValidationSwitch: true,
  apiUrl: 'https://myecomdev.nielseniq.cn/kwtool'
};
